import { render } from "./LocationTab.vue?vue&type=template&id=221af81c&scoped=true"
import script from "./LocationTab.vue?vue&type=script&lang=js"
export * from "./LocationTab.vue?vue&type=script&lang=js"

import "./LocationTab.vue?vue&type=style&index=0&id=221af81c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221af81c"]])

export default __exports__